import {Component, OnInit} from '@angular/core';
import {AngularFireFunctions} from "@angular/fire/compat/functions";
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {first} from "rxjs/operators";
import {Router} from "@angular/router";

@Component({
  selector: 'app-user-verification',
  templateUrl: './user-verification.component.html',
  styleUrls: ['./user-verification.component.css']
})
export class UserVerificationComponent implements OnInit {

  constructor(private afFun: AngularFireFunctions, private afAuth: AngularFireAuth, private router: Router) {
  }

  ngOnInit() {
    // refresh the token
    this.afAuth.user.pipe(first()).subscribe(value => value.getIdTokenResult(true).then(idTokenResult => {
      if (idTokenResult.claims.verified) {
        this.router.navigate(['/']);
      } else if (idTokenResult.claims.blocked) {
        this.router.navigate(['/blocked']);
      }
    }));
  }

}
